module.exports = __webpack_public_path__ + "img/ic_alarm_clock_2.d8f11a72.png";